<template>
    <div class="infra-container">
        <div class="banner">
            <div class="banner-content">
                <h1>我的订单</h1>
                <p>一站式查看所有已下单算力详细信息。</p>
            </div>
        </div>
        <div class="main-content">
            <div class="feature-cards">
                <el-card class="feature-card">
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <div class="card-content">
                                <div class="card-title">
                                    <img
                                        class="card-icon"
                                        src="../../assets/img/dingdan.png"
                                        alt=""
                                    />
                                    我的订单
                                </div>
                                <div class="card-value">
                                    {{ orderStatistics.num }}
                                    <span class="card-subtitle">单</span>
                                    <span class="card-tip">
                                        <span>本月</span>
                                        <span class="card-num"
                                            >新增{{
                                                orderStatistics.monthNum
                                            }}单</span
                                        >
                                    </span>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="card-content">
                                <div class="card-title">
                                    <img
                                        class="card-icon"
                                        src="../../assets/img/dingdanjine.png"
                                        alt=""
                                    />

                                    订单金额
                                </div>
                                <div class="card-value">
                                    <span class="unit">¥</span>
                                    {{ orderStatistics.amount }}
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="card-content">
                                <div class="card-title">
                                    <img
                                        class="card-icon"
                                        src="../../assets/img/suanli.png"
                                        alt=""
                                    />

                                    算力规模
                                </div>
                                <div class="card-value">
                                    {{ orderStatistics.computility }}
                                    <span class="card-subtitle">TFLOPS</span>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </el-card>
            </div>

            <!-- <div class="data-cards">
                <el-card class="data-card">
                    <div class="card-content">
                        <div class="card-title">
                            <img
                                class="card-icon"
                                src="../../assets/img/dingdan.png"
                                alt=""
                            />
                            我的订单
                        </div>
                        <div class="card-value">
                            24
                            <span class="card-subtitle">单</span>
                            <span class="card-tip">
                                <span>本月</span>
                                <span class="card-num">新增3单</span>
                            </span>
                        </div>
                    </div>
                </el-card>
                <el-card class="data-card">
                    <div class="card-content">
                        <div class="card-title">
                            <img
                                class="card-icon"
                                src="../../assets/img/dingdanjine.png"
                                alt=""
                            />

                            订单金额
                        </div>
                        <div class="card-value">
                            <span class="unit">¥</span>
                            2,862
                        </div>
                    </div>
                </el-card>
                <el-card class="data-card">
                    <div class="card-content">
                        <div class="card-title">
                            <img
                                class="card-icon"
                                src="../../assets/img/suanli.png"
                                alt=""
                            />

                            算力规模
                        </div>
                        <div class="card-value">
                            1,280
                            <span class="card-subtitle">TFLOPS</span>
                        </div>
                    </div>
                </el-card>
            </div> -->

            <div class="order-section">
                <h2>算力订单</h2>
                <div class="filter-row">
                    <el-row :gutter="16">
                        <el-col :span="5">
                            <el-select
                                v-model="orderSource"
                                placeholder="全部地区"
                                clearable
                                style="width: 100%"
                            >
                                <el-option
                                    :label="item.label"
                                    :value="item.value"
                                    v-for="(item, index) in regionOptions"
                                    :key="index"
                                /> </el-select
                        ></el-col>
                        <el-col :span="5"
                            ><el-select
                                v-model="goodsType"
                                placeholder="算力类型"
                                clearable
                                style="width: 100%"
                            >
                                <el-option
                                    :label="item.label"
                                    :value="item.value"
                                    v-for="(
                                        item, index
                                    ) in goodsCategoryOptions"
                                    :key="index"
                                /> </el-select
                        ></el-col>
                        <el-col :span="14"
                            ><el-input
                                v-model="codeOrName"
                                placeholder="搜索订单号查找订单"
                                prefix-icon="el-icon-search"
                                clearable
                                style="width: 100%"
                            >
                            </el-input
                        ></el-col>
                    </el-row>
                </div>

                <el-table
                    :data="orderList"
                    style="width: 100%"
                    class="order-table"
                >
                    <el-table-column
                        prop="orderCode"
                        label="订单号"
                        width="150"
                    />
                    <el-table-column
                        prop="ncnpOrderId"
                        label="国家平台单号"
                        width="170"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.ncnpOrderId">
                                {{ scope.row.ncnpOrderId }}
                                <i
                                    class="el-icon-copy-document"
                                    style="cursor: pointer; color: #1677ff; margin-left: 6px"
                                    title="复制"
                                    @click="copyText(scope.row.ncnpOrderId)"
                                ></i>
                            </span>
                            <span v-else class="empty-cell">—</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="externalOrderId"
                        label="外部平台单号"
                        width="140"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.externalOrderId">{{ scope.row.externalOrderId }}</span>
                            <span v-else class="empty-cell">—</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goodsName" label="算力配置">
                        <template slot-scope="scope">
                            <el-tooltip
                                :content="scope.row.goodsName"
                                placement="top"
                            >
                                <div class="spec-content">
                                    {{ scope.row.goodsName }}
                                </div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="goodsType"
                        label="算力类型"
                        width="100"
                    >
                        <template #default="scope">
                            {{
                                goodsCategoryOptions.find(
                                    (item) => item.value == scope.row.goodsType
                                )?.label || scope.row.goodsType
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="orderSource"
                        label="地区"
                        width="100"
                    >
                        <template #default="scope">
                            {{
                                regionOptions.find(
                                    (item) =>
                                        item.value == scope.row.orderSource
                                )?.label || scope.row.orderSource
                            }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="orderTime"
                        label="下单时间"
                        width="180"
                    />
                    <el-table-column
                        prop="orderAmount"
                        label="订单金额"
                        width="120"
                    >
                        <template slot-scope="scope">
                            {{ scope.row.orderAmount }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="paymentStatus" label="支付状态" width="110">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="getPaymentTagType(scope.row.paymentStatus)">
                                {{ getPaymentStatusText(scope.row.paymentStatus) }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="refundStatus" label="退款状态" width="110">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="getRefundTagType(scope.row.refundStatus)">
                                {{ getRefundStatusText(scope.row.refundStatus) }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="ncnpSyncStatus" label="同步状态" width="110">
                        <template slot-scope="scope">
                            <el-tag size="mini" :type="getSyncTagType(scope.row.ncnpSyncStatus)">
                                {{ getSyncStatusText(scope.row.ncnpSyncStatus) }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column fixed="right" label="操作" width="180">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                @click="viewOrderDetail(scope.row)"
                            >
                                订单详情
                            </el-button>
                            <el-button
                                v-if="scope.row.paymentStatus === 0 && (scope.row.ncnpOrderId || scope.row.channelOrderId)"
                                type="text"
                                @click="goPay(scope.row)"
                            >
                                去支付
                            </el-button>
                        </template>
                    </el-table-column>
                    <template slot="empty">
                        <div class="empty-block">
                            <img
                                src="../../assets/img/queshengye.png"
                                alt="暂无数据"
                                class="empty-image"
                            />
                            <div class="empty-text">您还没有订单</div>
                        </div>
                    </template>
                </el-table>

                <div class="pagination-container">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="current"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="size"
                        :total="total"
                        layout="total, sizes, prev, pager, next, jumper"
                        background
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import dict from "@/utils/dict";
import { ordersPage, ordersTop } from "@/api/index";
import { mapActions } from "vuex";
import { updateUrlParameters, noLoginTip } from "@/utils";
import { getLoginSource, getToken } from "@/utils/auth";

export default {
    name: "InfraIndex",
    data() {
        return {
            orderSource: "",
            goodsType: "",
            codeOrName: "",
            current: 1,
            size: 10,
            total: 0,
            orderList: [
                // {
                //     orderCode: "SH20250320000001",
                //     spec: "计算能力 200 GFLOPS，内存 32GB，网络带宽 1TB SSD + 2TB HDD（推荐配置）",
                //     region: "上海",
                //     orderTime: "2025-03-20 09:15:23",
                //     amount: "12,800",
                // },
            ],
            orderStatistics: {},
            paymentStatusOptions: {
                0: "未支付",
                1: "已支付",
                2: "已取消",
                3: "超时关闭",
                4: "支付失败",
            },
            refundStatusOptions: {
                0: "无退款",
                1: "退款中",
                2: "已退款",
                3: "退款失败",
            },
            syncStatusOptions: {
                0: "未同步",
                1: "已同步",
                2: "同步失败",
            },
            goodsCategoryOptions: dict.goodsCategoryOptions,
            regionOptions: dict.regionOptions,
        };
    },
    created() {
        this.ordersTopData();
        this.fetchOrders();
    },
    watch: {
        orderSource() {
            this.current = 1;
            this.fetchOrders();
        },
        goodsType() {
            this.current = 1;
            this.fetchOrders();
        },
        codeOrName() {
            this.current = 1;
            this.fetchOrders();
        },
    },
    methods: {
        ...mapActions("user", ["checkTokenValidity"]),

        handleSizeChange(val) {
            this.size = val;
            this.fetchOrders();
        },
        handleCurrentChange(val) {
            this.current = val;
            this.fetchOrders();
        },
        ordersTopData() {
            ordersTop({
                userId: localStorage.getItem("account"),
            }).then((res) => {
                this.orderStatistics = res.data;
            });
        },
        async fetchOrders() {
            try {
                const params = {
                    current: this.current,
                    size: this.size,
                    orderSource: this.orderSource,
                    goodsType: this.goodsType,
                    codeOrName: this.codeOrName,
                    userCode: localStorage.getItem("account"),
                };
                const response = await ordersPage(params);
                this.orderList = response.data.records;
                this.total = response.data.total;
                // 以本地 DB 为权威：列表只读本地 paymentStatus，不再逐单查远端 NCNP。
                // 支付状态由 NCNP 回调 / 对账 Job / 进"去支付"页时的查询回写本地，本处直接展示。
            } catch (error) {
                console.error("获取订单列表失败:", error);
                // this.$message.error('获取订单列表失败');
            }
        },
        viewOrderDetail(item) {
            // 跳本站订单详情页（orderDetailUrl 恒空，原逻辑无反应；改为本地详情）
            this.$router.push({ path: "/orders/detail", query: { id: item.id } });
        },
        goPay(item) {
            const query = {};
            if (item.ncnpOrderId) query.order_id = item.ncnpOrderId;
            if (item.channelOrderId) query.channel_order_id = item.channelOrderId;
            this.$router.push({ path: "/orders/pay", query });
        },
        getPaymentStatusText(status) {
            return this.paymentStatusOptions[status] || "未支付";
        },
        getRefundStatusText(status) {
            return this.refundStatusOptions[status] || "无退款";
        },
        getSyncStatusText(status) {
            return this.syncStatusOptions[status] || "未同步";
        },
        getPaymentTagType(status) {
            if (status == 1) return "success";
            if (status == 4) return "danger";
            if (status == 2 || status == 3) return "info";
            return "warning";
        },
        getRefundTagType(status) {
            if (status == 2) return "success";
            if (status == 3) return "danger";
            if (status == 1) return "warning";
            return "info";
        },
        getSyncTagType(status) {
            if (status == 1) return "success";
            if (status == 2) return "danger";
            return "info";
        },
        async copyText(text) {
            if (!text) return;
            try {
                if (navigator.clipboard && window.isSecureContext) {
                    await navigator.clipboard.writeText(text);
                } else {
                    const ta = document.createElement("textarea");
                    ta.value = text;
                    ta.style.position = "fixed";
                    ta.style.left = "-9999px";
                    document.body.appendChild(ta);
                    ta.select();
                    document.execCommand("copy");
                    document.body.removeChild(ta);
                }
                this.$message.success("已复制");
            } catch (e) {
                this.$message.error("复制失败");
            }
        },
    },
};
</script>

<style scoped lang="scss">
.infra-container {
    .banner {
        height: 320px;
        /* background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%); */
        color: white;
        display: flex;
        align-items: center;
        background-image: url("../../assets/bg/orderbeijing.png");
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;

        .banner-content {
            padding: 0 241px;

            h1 {
                font-size: 48px;
                margin-bottom: 16px;
            }

            p {
                font-size: 16px;
                opacity: 0.9;
                margin-bottom: 60px;
            }
        }
    }
    .main-content {
        margin: -60px auto 0;
        .data-cards {
            padding: 55px 241px 24px 241px;
            display: flex;
            gap: 24px;
            height: 300px;
            box-sizing: border-box;
            /* background: linear-gradient(
                to bottom,
                RGBA(96, 168, 246, 1),
                RGBA(114, 178, 247, 0.8),
                #fff
            ); */
            /* background-image: url("../../assets/bg/dingdanbeijing.png");
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat; */

            .data-card {
                height: 163px;
                flex: 1;
                background: linear-gradient(
                    to bottom,
                    RGBA(177, 212, 251, 0.9),
                    RGBA(193, 221, 251, 0.8),
                    RGBA(255, 255, 255, 0.7)
                );
                border: none;
                border-radius: 10px;
                box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

                :deep(.el-card__body) {
                    padding: 31px 29px;
                }

                .card-content {
                    .card-title {
                        font-weight: bold;
                        font-size: 18px;
                        color: #151519;
                        margin-bottom: 12px;
                        display: flex;
                        align-items: center;
                        .card-icon {
                            width: 33px;
                            height: 33px;
                            margin-right: 20px;
                        }
                    }

                    .card-value {
                        font-size: 32px;
                        font-weight: bold;
                        color: #333;
                        margin-bottom: 8px;
                        margin-left: 53px;

                        .unit {
                            font-size: 20px;
                        }

                        .card-subtitle {
                            font-size: 16px;
                            color: #656565;
                        }

                        .card-tip {
                            font-size: 16px;
                            color: #656565;
                            padding-left: 24px;

                            .card-num {
                                color: #1161f3;
                            }
                        }
                    }
                }
            }
        }

        .feature-cards {
            margin-bottom: 48px;
            padding: 0 241px;

            ::v-deep .el-card__body {
                padding: 45px;

                .el-col {
                    padding: 0 !important;
                    padding-right: 50px !important;
                }

                .el-col:not(:last-child) {
                    border-right: 1px solid #e8e8e8;
                }
                .el-col:not(:first-child) {
                    padding-left: 24px !important;
                }
            }

            .card-content {
                .card-title {
                    font-weight: bold;
                    font-size: 18px;
                    color: #151519;
                    margin-bottom: 12px;
                    display: flex;
                    align-items: center;
                    .card-icon {
                        width: 33px;
                        height: 33px;
                        margin-right: 20px;
                    }
                }

                .card-value {
                    font-size: 32px;
                    font-weight: bold;
                    color: #333;
                    margin-bottom: 8px;
                    margin-left: 53px;

                    .unit {
                        font-size: 20px;
                    }

                    .card-subtitle {
                        font-size: 16px;
                        color: #656565;
                    }

                    .card-tip {
                        font-size: 16px;
                        color: #656565;
                        padding-left: 24px;

                        .card-num {
                            color: #1161f3;
                        }
                    }
                }
            }

            .feature-card {
                height: 100%;

                .feature-card-title {
                    display: flex;
                    align-items: center;
                    .icon {
                        width: 31px;
                        height: 31px;
                        margin-right: 10px;
                    }
                    .title {
                        font-weight: bold;
                        font-size: 18px;
                        color: #151519;
                    }
                }

                .feature-card-remark {
                    font-size: 16px;
                    color: #656565;
                    line-height: 26px;
                    margin-bottom: 0;
                }
            }
        }

        .order-section {
            padding: 0 241px 24px 241px;
            /* margin-top: -40px; */

            h2 {
                font-size: 26px;
                color: #333;
                font-weight: normal;
                margin: 0 0 24px 0;
            }

            .filter-row {
                /* display: flex;
                gap: 16px; */
                margin-bottom: 24px;

                .el-select {
                    width: 180px;
                }

                .search-input {
                    width: 300px;
                }
            }

            .order-table {
                margin-bottom: 24px;

                .spec-content {
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                ::v-deep .el-table__header {
                    background-color: #f5f5f5;

                    .el-table__cell {
                        background-color: #f5f5f5;
                        color: #656565;
                    }
                }

                :deep(.el-table__row) {
                    .el-button--text {
                        padding: 0;
                        height: auto;
                        font-size: 14px;
                    }
                }

                .empty-block {
                    padding: 100px 0;
                    .empty-image {
                        width: 318px;
                    }
                    .empty-text {
                        font-weight: bold;
                        font-size: 18px;
                        color: #999999;
                        margin-left: 18px;
                        line-height: 20px;
                    }
                }
            }

            .pagination-container {
                display: flex;
                justify-content: center;
                margin-top: 35px;
            }
        }
    }
}
</style>
